"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.listenRouter = listenRouter;
const browser_router_1 = require("@rws-framework/browser-router");
function listenRouter() {
    this.$emit(browser_router_1._ROUTING_EVENT_NAME, (route_event) => {
        this.currentPage = route_event.routeName;
    });
    this.on('routing.url.changed', (event) => {
        const url = event.detail.item;
        const hash = event.detail.hash;
        this.currentUrl = url;
        this.currentHash = hash;
    });
}
